import { useQuery } from '@tanstack/react-query'
import { ModuleHeader, Text } from '@viapeople/components'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { trpc } from '../../utils/trpc'

import { DataFeedConfigModal } from './DataFeedConfigModal'
import { IntegrationCard } from './IntegrationCard'
import { SpiralinksIntegrationModal } from './SpiralinksIntegrationModal'
import { UkgRaasDataFeedConfigModal } from './UkgRaasDataFeedConfigModal'

export function IntegrationsPage() {
	const { organizationId } = useParams<{ organizationId: string }>()
	const [isSpiralinksModalOpen, setIsSpiralinksModalOpen] = useState(false)
	const [isDataFeedModalOpen, setIsDataFeedModalOpen] = useState(false)
	const [isUkgModalOpen, setIsUkgModalOpen] = useState(false)

	const { data: spiralinksIntegration } = useQuery({
		...trpc.admin.integrations.spiralinks.getByOrganizationId.queryOptions({
			organizationId: organizationId as string,
		}),
		enabled: !!organizationId,
	})

	const { data: dataFeedConfig } = useQuery({
		...trpc.admin.integrations.dataFeed.getByOrganization.queryOptions({
			organizationId: organizationId as string,
			adapterType: 'sftp',
		}),
		enabled: !!organizationId,
	})

	const { data: ukgConfig } = useQuery({
		...trpc.admin.integrations.dataFeed.getByOrganization.queryOptions({
			organizationId: organizationId as string,
			adapterType: 'ukg_raas',
		}),
		enabled: !!organizationId,
	})

	return (
		<main className='p-6'>
			<ModuleHeader
				breadcrumb={[{ label: 'Organizations', to: '/organizations' }, { label: 'Integrations' }]}
				title='Integrations'
			/>
			<Text variant='h4' weight='semibold' className='justify-self-start mb-2'>
				Configure third-party integrations for your organization
			</Text>
			<div className='mt-8'>
				<Text variant='h5' weight='semibold' className='mb-4'>
					Available Integrations
				</Text>

				<div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'>
					<IntegrationCard
						title='Spiralinks'
						description='Connect your organization with Spiralinks for seamless performance reviews and feedback management.'
						configured={!!spiralinksIntegration}
						onClick={() => setIsSpiralinksModalOpen(true)}
					/>

					<IntegrationCard
						title='Data Feed (SFTP)'
						description='Automatically import user population from CSV/XLSX files uploaded to an SFTP share on an hourly schedule.'
						configured={!!dataFeedConfig}
						onClick={() => setIsDataFeedModalOpen(true)}
					/>

					<IntegrationCard
						title='Data Feed (UKG Pro)'
						description='Automatically import user population from UKG Pro Reports as a Service (RaaS) on an hourly schedule.'
						configured={!!ukgConfig}
						onClick={() => setIsUkgModalOpen(true)}
					/>
				</div>
			</div>

			<SpiralinksIntegrationModal
				isOpen={isSpiralinksModalOpen}
				onClose={() => setIsSpiralinksModalOpen(false)}
				organizationId={organizationId as string}
				existingIntegration={spiralinksIntegration}
			/>

			<DataFeedConfigModal
				isOpen={isDataFeedModalOpen}
				onClose={() => setIsDataFeedModalOpen(false)}
				organizationId={organizationId as string}
				existingConfig={dataFeedConfig}
			/>

			<UkgRaasDataFeedConfigModal
				isOpen={isUkgModalOpen}
				onClose={() => setIsUkgModalOpen(false)}
				organizationId={organizationId as string}
				existingConfig={ukgConfig}
			/>
		</main>
	)
}
